module.exports = __webpack_public_path__ + "static/media/devoluciones.d15ad3f0.svg";